module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', {
    staticClass: "f6 b db mb2",
    attrs: {
      "for": "stateOrProvince"
    }
  }, [_vm._v("\n    State/Province\n  ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedState),
      expression: "selectedState"
    }],
    staticClass: "ba b--black-20 pa2 mb2 db w-100 br1",
    attrs: {
      "name": "stateOrProvince"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedState = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select a State")]), _vm._v(" "), _vm._l((_vm.statesAndProvinces), function(usState) {
    return _c('option', {
      key: usState.code,
      domProps: {
        "value": usState.code
      }
    }, [_vm._v("\n      " + _vm._s(usState.code) + "\n    ")])
  })], 2)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-53545168", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53545168","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/registration-v2/StateDropdown.vue
// module id = 1366
// module chunks = 0